import { api } from '../config/api'

const metricsBaseEndpoint = '/MetricApi'
const schoolsBaseEndpoint = '/SchoolApi'

export const getApproachByCategoryInfo = params =>
  api.get(`${metricsBaseEndpoint}/CategoryMetric`, { params })

export const getSchools = () =>
  api.get(`${schoolsBaseEndpoint}/GetUserSchools`)

export const getResourcesMoreValuedByFilters = params =>
  api.get(`${metricsBaseEndpoint}/ReviewCategoryMetric`, { params })

export const getChosenMethodologies = params =>
  api.get(`${metricsBaseEndpoint}/ChosenMethodologies`, { params })

export const getChosenSkills = params =>
  api.get(`${metricsBaseEndpoint}/ChosenSkills`, { params })

export const getMostValuedResources = params =>
  api.get(`${metricsBaseEndpoint}/MostValuedByTeachers`, { params })
